module.exports = __webpack_public_path__ + "8a5356e9/img/SOURCERY_poweredby_web.9819842b.png";